import { RadarPage } from '@backstage/plugin-tech-radar';

export const FactoryTechRadarPage = () => (
  <RadarPage
    height={800}
    pageTitle="C4CI Product Technology Radar"
    subtitle="Technology choices currently shaping C4CI product delivery"
    title="C4CI Tech Radar"
    width={1500}
  />
);
